import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "meal-plan" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "meal-plan-box ws-textbox my-4 py-2 ws-textbox__meal-plan" }
const _hoisted_7 = { style: {"margin":"0"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "icon-clock-wrapper"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock" }, null, -1)
const _hoisted_12 = { class: "mx-1" }
const _hoisted_13 = { class: "icon-money-wrapper mr-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "ws-textbox my-4 py-2 ws-textbox__meal-plan" }
const _hoisted_19 = { style: {"margin":"0"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "far fa-clock",
  style: {"font-size":"20px","color":"#37c5e7"}
}, null, -1)
const _hoisted_25 = { class: "mx-1" }
const _hoisted_26 = { class: "icon-money-wrapper" }
const _hoisted_27 = {
  key: 0,
  class: "fas fa-money-bill-wave"
}
const _hoisted_28 = {
  key: 1,
  class: "mx-1"
}
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "group-button" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemOfVoucher = _resolveComponent("ItemOfVoucher")!
  const _component_StyledVoucherSharing = _resolveComponent("StyledVoucherSharing")!

  return (_openBlock(), _createBlock(_component_StyledVoucherSharing, null, {
    default: _withCtx(() => [
      _createVNode(_component_ItemOfVoucher, {
        label: _ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_9 || 'Meal Plan voucher',
        color: "#f5b945",
        icon: "images/icon-voucher/meal-plan-voucher.png"
      }, null, 8, ["label"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "ws-textbox mt-4 py-1",
              innerHTML: _ctx.description()
            }, null, 8, _hoisted_4),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mealPlanList, (mealPlan, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (_ctx.checkOldMealPlan(mealPlan))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mealPlanInDay, (m, k) => {
                        return (_openBlock(), _createElementBlock("div", { key: k }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", _hoisted_7, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.getLang(m)), 1),
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDateOldMealPlan(mealPlan.date)), 1)
                            ]),
                            (!_ctx.checkHaveMealPlan(mealPlan, m))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_3), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  (_ctx.getTimeOldMealPlan(mealPlan, m) !== '')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getTimeOldMealPlan(mealPlan, m)), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_13, [
                                    (_ctx.checkPrice(mealPlan, m))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getPrice(mealPlan, m)) + " " + _toDisplayString(mealPlan.currency) + " " + _toDisplayString(_ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_4), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_2), 1)),
                                    (_ctx.setListGroup().length > 1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setListGroup(), (pax, i) => {
                                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                                              _createElementVNode("span", null, _toDisplayString(pax), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["meal-plan-box", { 'meal-plan-box--used': mealPlan.is_used, 'meal-plan-box--expired': _ctx.checkExpired(mealPlan) }])
                        }, [
                          _createElementVNode("p", _hoisted_19, [
                            (mealPlan.type === 1 || mealPlan.type === 6)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.getLang('Breakfast')), 1))
                              : (mealPlan.type === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.getLang('Lunch')), 1))
                                : (mealPlan.type === 3)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.getLang('Dinner')), 1))
                                  : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(mealPlan.mealplan_time)), 1)
                          ]),
                          (!_ctx.isBreakfastHrsInclude(mealPlan))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _hoisted_24,
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getTimeMealPlan(mealPlan)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_26, [
                            (Number(mealPlan.valamount.replace('.00', '')))
                              ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                              : _createCommentVNode("", true),
                            (Number(mealPlan.valamount.replace('.00', '')))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(mealPlan.valamount.replace('.00', '')) + " " + _toDisplayString(mealPlan.currency) + " " + _toDisplayString(mealPlan.is_used ? _ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_12 : ''), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.groundHandlerMessage?.meal_plan_sharing.SFS_LANG_ROW_2), 1))
                          ])
                        ], 2)
                      ])
                    ]))
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          class: "btn-action",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToHomePage()))
        }, _hoisted_32)
      ])
    ]),
    _: 1
  }))
}